import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';



@NgModule({
  imports: [
    ConfigModule.withConfig({
      layoutSlots: {
        header: {
          lg: {
            slots: [
              'TopHeaderSlot',

              'PreHeader',

              'SiteContext',

              'SiteLinks',

              'SiteLogo',

              'NavigationBar',

              'MiniCart',



            ],
          },

          md: {
            slots: [
              'TopHeaderSlot',

              'PreHeader',

              'SiteContext',

              'SiteLinks',

              'SiteLogo',

              'NavigationBar',

              'MiniCart',

            ],
          },

          sm: {
            slots: [
              'TopHeaderSlot',

              'PreHeader',

              'SiteContext',

              'SiteLinks',

              'SiteLogo',

              'MiniCart',

              'NavigationBar',



            ],
          },

          xs: {
            slots: [

              'TopHeaderSlot',

              'SiteContext',

              'PreHeader',

              'SiteLogo',

              'MiniCart',

              'SiteLinks',


            ],
          },
        },

        navigation: {
          lg: { slots: [] },

          slots: ['NavigationBar', 'SiteContext', 'SiteLinks'],
        },

        footer: {
          slots: ['Footer'],
        },

        LandingPage2Template: {
          pageFold: 'Section2B',

          slots: [














            'Section5',

            'HeroImageShippingBannerSlot',

            'HeroImageBanner',

            'Section2C',

            'Section2B',

            'Section3',

            'Section4',

            'MatNumber'
          ],
        },
        LandingOperationalSolutionPage2Template: {
          slots: [
            'solutionsPage1Section1',

            'solutionsPage1Sections3',

            'solutionsPage1Section5',

            'MatNumber'
          ]
        },
        LandingSolutionPage3Template: {
          slots: [
            'SolutionsPage3Section1',

            'SolutionsPage3Sections3',

            'SolutionsPage3Section5',

            'MatNumber'
          ]
        },
        LandingDataSolutionPage2Template: {
          slots: [
            'dataSolutionPageSection1',

            'dataSolutionPageSections3',

            'dataSolutionPageSection5',

            'MatNumber'
          ]
        },
        LandingCostSavingsSolutionPage2Template: {
          slots: [
            'costSavingsSolutions1Section1',

            'costSavingsSolutions1Sections3',

            'costSavingsSolutions1Section5',

            'MatNumber'
          ]
        },
        LandingSolutionPage2Template: {
          slots: [


            'consultativeSolutionsPageSection1',

            'consultativeSolutionsPageSections3',

            'consultativeSolutionsPageSection5',

            'MatNumber'

          ]
        },
        LandingPage2Template1: {
          slots: [
            'aboutVaxServe2Section1',

            'aboutVaxServe2Sections3',

            'aboutVaxServe2Section5',

            'MatNumber'
          ]
        },
        ContentPage1Template: {
          slots: ['FAQ-left', 'CommunicationComp', 'TrainingComp', 'BusinessPlans-left', 'Internalreportsandcommunications-left', 'BodyContent', 'BodyContentReimbursement',
            'MatNumber']
        },
        CategoryPageTemplate: {
          pageFold: 'Section2',

          slots: ['Section1', 'Section2', 'Section3', 'MatNumber'],
        },
        fluseasonreservationpagetemplate: {
          slots: ['FluReservationDeliveryHoursBannerSlot', 'FluParaMiddleSlottop', 'FluParaMiddleSlottest', 'FluParaMiddleSlot', 'SanofiFluDashboardBottomLeft', 'SanofiFluDashboardBottomRight', 'MatNumber']
        },
        WaitListPageTemplate: {
          slots: ['BodyContent', 'MatNumber'
          ],
        },
        RecurringPageTemplate: {
          slots: ['BodyContent', 'MatNumber'
          ],
        },
        FluSeasonProductListPageTemplate: {//template
          slots: ['SelectVaccineSlot', 'FluViewCheckoutSlot', 'MatNumber'], //position of component
        },
        FluSeasonPaymentPageTemplate: {
          slots: ['FluViewCheckoutSlot', 'MatNumber'],
        },
        FluSeasonViewCartPageTemplate: {
          slots: ['FluCartMarketBannerContentSlot', 'FluViewCartSlot', 'MatNumber']
        },
        flureserrvationconfirmpagetemplate: {
          slots: ['FluViewConfirmationSlot', 'MatNumber']
        },
        flureservationoverviewpagetemplate: {
          slots: ['FlureservationOverViewSlot', 'MatNumber']
        },



        ProductListPageTemplate: {
          slots: ['ProductLeftRefinements', 'ProductListSlot', 'MatNumber'],
        },

        ProductGridPageTemplate: {
          slots: ['SanofiPLPAlertContenSlot', 'ProductGridHorizontalBanner', 'FutureShipModelContentSlot', 'ProductLeftRefinements', 'ProductGridSlot', 'PLPLeftBanner',
            'MatNumber'],
        },
        FormularyGridPageTemplate: {
          slots: ['SanofiPLPAlertContenSlot', 'FutureShipModelContentSlot', 'ProductLeftRefinements', 'ProductGridSlot', 'MatNumber'],
        },
        SearchResultsListPageTemplate: {
          slots: [
            'Section2',

            'ProductLeftRefinements',

            'SearchResultsListSlot',

            'Section4',

            'MatNumber'
          ],
        },

        SearchResultsGridPageTemplate: {
          slots: [
            'Section2',

            'ProductLeftRefinements',

            'SearchResultsGridSlot',

            'Section4',

            'MatNumber'
          ],
        },

        ProductDetailsPageTemplate: {
          lg: {
            pageFold: 'UpSelling',
          },

          pageFold: 'Summary',

          slots: [
            'Summary',

            'PDPRightBanner',

            'UpSelling',

            'CrossSelling',


            'MatNumber'
          ],
        },

        CartPageTemplate: {
          slots: [
            'TopContent',

            'CenterRightContentSlot',
            'SanofiCartPageBannerSlot',
            'EmptyCartMiddleContent',
            'BottomContentSlot',
            'MatNumber'
          ],
        },
        AccountPageTemplate: {
          slots: ['ContentSlotHeaderBannerOrdersListing', 'VaxServeContactUsPageBodySlot',
            'BannerContent', 'SideContent', 'BodyContent', 'CustomerService-left', 'LeftSectionContent', 'ReportBeforeLoginSlot', 'TransactionalDataSlot', 'faqcontent', 'BodyContent-invoicePayment', 'BodyContent-order-approval-dashboard',
            'BodyContent-order-approval-details', 'MatNumber'],
        },
        AccountPage1Template1: {
          slots: ['LeftSectionContent', 'UsefulLinks'],
        },
        ContactUSPageTemplate: {
          slots: ['Section1', 'BodyContent', 'Section5', 'MatNumber']
        },
        ImmunizationSchedulesPageTemplate: {
          slots: ['immunizationschedules-Leftsection', 'immunizationschedules-Rightsection', 'MatNumber'],
        },
        VaccinesForChildrenPageTemplate: {
          slots: ['vaccinesforchildren-Leftsection', 'vaccinesforchildren-Rightsection', 'MatNumber'],
        },
        MakeAPaymentPageTemplate: {
          slots: ['BannerContent', 'BannerContentTop', 'BodyContent', 'BodyContent-invoices', 'BodyContent-openInvoicePayment', 'BodyContent-OpenInovoiceReview',
            'BodyContent-openInvoicePaymentConfirmation', 'BodyContent-invoices-credits', 'MatNumber'
          ],
        },
        salesAgentResetPasswordPageTemplate: {
          slots: ['salesAgentresetPasswordSlot', 'NeedAssistanceSlot', 'MatNumber']
        },
        salesAgentResetPasswordConfirmationPageTemplate: {
          slots: ['salesAgentresetPasswordConfirmationSlot', 'NeedAssistanceSlot', 'MatNumber']
        },
        salesAgentResetPasswordFailurePageTemplate: {
          slots: ['salesAgentResetPasswordFailure', 'NeedAssistanceSlot', 'MatNumber']
        },
        flureservationoverviewdetailspagetemplate: {
          slots: ['FlureservationOverViewSlot', 'MatNumber']
        },
        PaymentHistorypagetemplate: {
          slots: ['MarketingBanner', 'MatNumber']
        },
        LoginPageTemplate: {
          lg: {
            slots: [
              'SanofiAccountDashboardAlertBannerSlot',

              'SanofiAOProductGridBanner',
              'SanofiAccountOverrivewContenSlot',
              'LeftContentSlot',
              'AccountOverviewDeliveryHoursBannerSlot',
              'AccountOverviewOrdersSlot',
              'AccountOverviewPlaceholderSlot2',

              'RegistrationSlot',
              'CustomerRegistrationSlot',
              'RegistrationPageSlot',

              'SanofiAccountOverviewBannerSlot5',
              'AccountOverviewFinancialsSlot',

              'SanofiAccountDashboardFluReservationsCMSSlot',
              'SanofiAccountOverviewBannerSlot6',
              'AccountOverviewPlaceholderSlot',
              'SanofiAccountOverviewBannerSlot',
              'SanofiAccountOverviewBannerComponent4',
              'SanofiAccountOverviewBannerSlot4',
              'MatNumber'
            ],
          },
          sm: {
            slots: [
              'SanofiAccountDashboardAlertBannerSlot',

              'SanofiAOProductGridBanner',
              'SanofiAccountOverrivewContenSlot',
              'LeftContentSlot',
              'AccountOverviewDeliveryHoursBannerSlot',
              'SanofiAccountOverviewBannerSlot',
              'AccountOverviewOrdersSlot',
              'AccountOverviewPlaceholderSlot2',
              'RightContentSlot',
              'RegistrationSlot',
              'CustomerRegistrationSlot',
              'RegistrationPageSlot',
              'NewsAndUpdatesSlot',
              'SanofiAccountOverviewBannerSlot5',
              'SanofiAccountOverviewBannerSlot2',
              'AccountOverviewFinancialsSlot',
              'SanofiAccountDashboardFluReservationsCMSSlot',
              'SanofiAccountOverviewBannerSlot6',
              'AccountOverviewPlaceholderSlot',
              'SanofiAccountOverviewBannerSlot4',
              'MatNumber'
            ]
          },
          xs: {
            slots: [
              'SanofiAccountDashboardAlertBannerSlot',

              'SanofiAOProductGridBanner',
              'SanofiAccountOverrivewContenSlot',
              'LeftContentSlot',
              'SanofiAccountOverviewBannerSlot',
              'AccountOverviewOrdersSlot',
              'AccountOverviewFinancialsSlot',
              'SanofiAccountDashboardFluReservationsCMSSlot',
              'AccountOverviewDeliveryHoursBannerSlot',
              'SanofiAccountOverviewBannerSlot6',

              'AccountOverviewPlaceholderSlot2',
              'RightContentSlot',
              'RegistrationSlot',
              'CustomerRegistrationSlot',
              'RegistrationPageSlot',
              'NewsAndUpdatesSlot',

              'AccountOverviewPlaceholderSlot',
              'SanofiAccountOverviewBannerSlot5',
              'SanofiAccountOverviewBannerSlot2',
              'SanofiAccountOverviewBannerSlot4',
              'MatNumber'
            ],
          },
        },
        RegistrationPageTemplate: {
          slots: [
            'CustomerRegistrationSlot',
            'RegistrationPageSlot',
            'ProductMonogragh-Slot',
            'AccountOverviewProductMonographContentSlot',

          ],
        },
        CustomerRegisterPageTemplate: {
          slots: [
            'RegistrationSlot',
            'CustomerRegistrationSlot',


          ],
        },
        CustomerRegisterConfirmPageTemplate: {
          slots: [
            'RegistrationSlot',


          ],
        },
        RegisterPageTemplate: {
          slots: [
            'RegistrationSlot',
            'UserRegisterBannerSlot',

          ],
        },
        RegisterConfirmPageTemplate: {
          slots: [
            'RegistrationSlot',
            'UserRegisterBannerSlot',

          ],
        },
        LoginHelpPageTemplate: {
          slots: [
            'BodyContent',
            'NeedAssistanceSlot',
            'loginHelpMarketBannerContentSlot',
            'MatNumber'
          ],
        },
        ErrorPageTemplate: {
          slots: ['TopContent', 'MiddleContent', 'BottomContent', 'MatNumber'],
        },

        OrderConfirmationPageTemplate: {
          slots: ['BodyContent', 'SideContent', 'MatNumber'],
        },

        OrderConfirmationTemplate: {
          slots: ['StdOrderConfTopContenSlot', 'CenterLeftContentSlot', 'MatNumber'],
        },

        orderConfirmationFluTemplate: {
          slots: ['FluOrderConfTopContenSlot', 'ConfirmationFluPage-Leftsection', 'MatNumber'],
        },

        MultiStepCheckoutSummaryPageTemplate: {
          slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent', 'MatNumber'],
        },

        CheckoutLoginPageTemplate: {
          slots: ['RightContentSlot', 'MatNumber'],
        },
        CheckoutPageTemplate: {
          slots: ['SanofiCheckoutPageBannerSlot', 'EmptyCheckOutMiddleContent', 'MatNumber']
        },
        ConfirmOrderPageTemplate: {
          slots: ['BodyContent', 'MatNumber']
        },
        sanofiMediacalResourcesPagetemplate: {
          slots: ['MedicalResourceComp', 'healthcarevertical', 'healthcarehorizantal', 'MatNumber']
        },
        sanofiResourcesPageTemplate: {
          slots: ['patientEducationPaginationSlot', 'patientEducation-vertical', 'patientEducation-Horizontal', 'MatNumber']
        },
        SaveOrderPageTemplate: {
          slots: ['BodyContent', 'NeedAssistance', 'MatNumber']
        },
        sanofiRequestResourcesPagetemplate: {
          slots: ['requestResourceComp', 'MatNumber']
        },
        sanofiRequestResourcesConfirmationPagetemplate: {
          slots: ['requestconfirmation', 'MatNumber']
        },
        notificationMessageTemplate: {
          slots: ['MultiLocationSelector', 'MatNumber']
        },
        notificationMessageDetailsTemplate: {
          slots: ['PlaceholderContentSlot', 'MatNumber']
        },
        FluReservationPageTemplate: {
          slots: ['SelectVaccineSlot', 'MatNumber']
        },
        FluverifypaymentPageTemplate: {
          slots: ['topFluverifypaymentPage', 'MatNumber']
        },
        VaccineLocatorTemplate: {
          slots: ['FlulocatorContentSlot', 'MatNumber']
        },
        inmarreturnspagetemplate: {
          slots: ['CreateReturnMainContentSlotName', 'MatNumber']
        },
        sanofiReturnsPageTemplate: {
          slots: ['returnsInformationParagraphSlot', 'MatNumber']
        },
        tierManagementpagetemplate: {
          slots: ['STSTierMangementSlot', 'MatNumber']
        },
        STSCustomerUploadAdminPageTemplate: {
          slots: ['STSCustomerUploadSlot', 'MatNumber']
        },
        STSShippingWeekPageTemplate: {
          slots: ['STSShippingWeekSlot', 'MatNumber']
        },
        shipCommitmentpagetemplate: {
          slots: ['STSShipCommitmentSlot', 'MatNumber']
        },
        stsorderexportpagetemplate: {
          slots: ['STSExportOrder', 'MatNumber']
        },
        UserManagementTemplate: {
          slots: ['UserRecordSearchSlot', 'MatNumber']
        },
        STSMarketingAnalysisPageTemplate: {
          slots: ['STSMarketingAnalysisSlot', 'MatNumber']
        },
        SanofiRulesLandingPageTemplate: {
          slots: ['ShippingRuleSlot', 'MatNumber']
        },
        CustomerOverviewTemplate: {
          slots: ['UserDetailPageSlot', 'MatNumber']
        },
        FutureShipPageTemplate: {
          slots: ['FutureShipPageSlot', 'MatNumber']
        },
        FluReservationStsPageTemplate: {  // template of cms page
          slots: ['ScheduleLaterContent', 'MatNumber'] //position of required slot
        },
        CustomerHierarchyPageTemplate: {
          slots: ['BodyContent', 'MatNumber']
        },
        sanofiOnlineSupportPageTemplate: {  // template of cms page
          slots: ['ContentSearchBox', 'ContentItemsSlot', 'LeftNavigationSlot', 'MatNumber'] //position of required slot
        },
        sanofiContentSearchPageTemplate: {

          slots: [
            'ContentSearchBox',
            'ContentSearchResult',
            'LeftNavigationSlot',
            'MatNumber'
          ], //position of required slot
        },
        ReimburseSupportServiceTemplate: {
          slots: ['BodyContent', 'BodyContentReimburseSupport', 'MatNumber']
        },
      },
    } as LayoutConfig),
  ],
})
export class LayoutConfigModule { }
